import { PickedFile } from './picked-file';
import { ReadMode } from './read-mode.enum';
export class PickedFileImpl implements PickedFile {
/**
 * @return {?}
 */
get lastModifiedDate(): Date {
    return this._lastModifiedDate;
  }
/**
 * @return {?}
 */
get name(): string {
    return this._name;
  }
/**
 * @return {?}
 */
get size(): number {
    return this._size;
  }
/**
 * @return {?}
 */
get type(): string {
    return this._type;
  }
/**
 * @return {?}
 */
get readMode(): ReadMode {
    return this._readMode;
  }
/**
 * @return {?}
 */
get content(): any {
    return this._content;
  }
/**
 * @param {?} _lastModifiedDate
 * @param {?} _name
 * @param {?} _size
 * @param {?} _type
 * @param {?} _readMode
 * @param {?} _content
 */
constructor(
private _lastModifiedDate: Date,
private _name: string,
private _size: number,
private _type: string,
private _readMode: ReadMode,
private _content: any) {
  }
}

function PickedFileImpl_tsickle_Closure_declarations() {
/** @type {?} */
PickedFileImpl.prototype._lastModifiedDate;
/** @type {?} */
PickedFileImpl.prototype._name;
/** @type {?} */
PickedFileImpl.prototype._size;
/** @type {?} */
PickedFileImpl.prototype._type;
/** @type {?} */
PickedFileImpl.prototype._readMode;
/** @type {?} */
PickedFileImpl.prototype._content;
}

